<template>
  <div class="date-selector">

    {{ value }} - {{ selectedDuration }}
    <div v-if="editMode">
      <el-input
        ref="duration_selector"
        class="inline-date-select"
        style="width: 80px"
        v-model="selectedDuration"
        :placeholder="placeholder"
        :size="size"
        @change="onUpdate" />
      <!-- <a href="#" @click.prevent="onChangeUnit">{{selectedUnit}}</a> -->
      <el-select v-model="selectedUnit" :size="size" style="width: 100px" @change="onUpdate">
        <el-option label="hours" value="hours" />
        <el-option label="minutes" value="minutes" />
      </el-select>
      <el-button
        v-if="show_confirm_button"
        :size="size"
        type="success"
        @click="onSave"
        style="position: relative; margin-left: 2px">ok</el-button>
    </div>
    <template v-if="!editMode">
      <a href="#" @click.prevent="onStartEditMode">
        <template v-if="selectedDuration">{{selectedDuration}}</template>
        <template v-else>{{placeholder}}</template>
        {{selectedUnit}}
      </a>
    </template>
  </div>
</template>

<script>
function unitToFactor(unit) {
  switch (unit) {
    case 'hours': return 60;
    case 'minutes': return 1;
  }
}

export default {
  props: {
    show_confirm_button: {
      default: true
    },
    placeholder: {
      default: null
    },
    unit: {
      default: 'hours'
    },
    value: {
      // This value is always minutes
      default: 30 * 60
    },
    size: {
      default: 'medium'
    },
  },
  data: () => ({
    editMode: false,
    selectedDuration: null,
    selectedUnit: null
  }),
  mounted() {
    this.selectedUnit = this.unit;
    this.selectedDuration = this.unit === 'hours' ? ( this.value / 60 ) : this.value;
  },
  methods: {
    onStartEditMode() {
      this.editMode = !this.editMode;
      this.$nextTick(() => {
        this.$refs.duration_selector.focus();
      })
    },

    onUpdate(e) {
      let factor = 1;
      if ( e === 'minutes' ) {
        factor = 60
      } else if ( e === 'hours' ) {
        factor = 1 / 60
      }
      this.selectedDuration = +(Math.round(parseFloat( this.selectedDuration ) + "e+2")  + "e-2");
      this.selectedDuration *= factor;

      this.$emit('input', this.selectedDuration * unitToFactor( this.selectedUnit ));

      if ( !this.show_confirm_button ) {
        this.onSave();
      }
    },

    onSave() {
      console.log("onSave", this.selectedDuration);
      this.editMode = false;
      this.$emit('save', this.selectedDuration)
    },

    onChangeUnit() {
      this.selectedUnit = this.selectedUnit === 'hours' ? 'minutes' : 'hours'
    }
  }
}
</script>

<style>
</style>
